import React from 'react';

const Icon = ({ fill }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 18">
            <path
                d="M10 0C15.5 0 20 3.58 20 8C20 12.42 15.5 16 10 16C8.76 16 7.57 15.82 6.47 15.5C3.55 18 0 18 0 18C2.33 15.67 2.7 14.1 2.75 13.5C1.05 12.07 0 10.13 0 8C0 3.58 4.5 0 10 0Z"
                fill={fill}
            />
        </svg>
    );
};

export default Icon;
